export default "__VITE_ASSET__DYpUr$Rt__"